import { api } from '../client';

// Admin API exports
export * from './clients.api';
export * from './products.api';

// Analytics API placeholder functions
export const getAnalyticsData = async () => {
  return {
    revenue: [],
    customers: [],
    orders: [],
  };
};

export const getFinancialReports = async () => {
  return {
    reports: [],
  };
};

export const getCustomerAnalytics = async () => {
  return {
    analytics: [],
  };
};

// Helper to ensure paths have /admin prefix
function adminPath(url: string): string {
  if (url.startsWith('/admin/') || url.startsWith('/admin?')) return url;
  return `/admin${url.startsWith('/') ? '' : '/'}${url}`;
}

// Export adminApi for components that need it
// All generic HTTP methods automatically prepend /admin to paths
export const adminApi = {
  // Generic HTTP methods (auto-prefix /admin)
  get: (url: string, config?: any) => api.get(adminPath(url), config),
  post: (url: string, data?: any, config?: any) => api.post(adminPath(url), data, config),
  put: (url: string, data?: any, config?: any) => api.put(adminPath(url), data, config),
  delete: (url: string, config?: any) => api.delete(adminPath(url), config),
  patch: (url: string, data?: any, config?: any) => api.patch(adminPath(url), data, config),

  // Named convenience methods
  getPromotions: () => api.get('/admin/promotions'),
  createPromotion: (data: any) => api.post('/admin/promotions', data),
  updatePromotion: (id: number, data: any) => api.put(`/admin/promotions/${id}`, data),
  deletePromotion: (id: number) => api.delete(`/admin/promotions/${id}`),
};
